import Checkbox from "./checkbox";
import Checkboxes from "./checkboxes";
import Dropdown from "./dropdown";
import Image from "./image";
import Radio from "./radio";
import StylingPreview from "./styling-preview";
import Text from "./text";

export default {
  checkbox: Checkbox,
  checkboxes: Checkboxes,
  "styling-preview": StylingPreview,
  dropdown: Dropdown,
  image: Image,
  text: Text,
  radio: Radio,
};
